// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"aa2076e6","291":"d074e424","309":"ee790da3","531":"f8b2e42b","672":"27328b79","823":"ff461b0d","895":"6e2a84a1"}[chunkId] + ".chunk.css";
};